import { axiosGetHandler, axiosPostHandler } from './config';

// 获取通用JSON，配置地址：https://heybox.debugmode.cn/game/dashboard_v2/activity/common_json?json_id=66875b1a1ba4e6cd51f4e5c9
export function getCommonJSON(args) {
  let url = '/game/common_json';
  return axiosGetHandler(url, args);
}

// 获取基础 heybox 信息
export function getHeyboxInfo(args) {
  let url = '/account/get_user_base_info';
  return axiosGetHandler(url, args);
}

// 获取字体文件
export function getFontFile(args, formData) {
  var url = `${window.$WEB_HOST}/tool/get_font_file`;
  return axiosPostHandler(url, args, formData);
}

// 获取社区举报原因
export function getCommunityReportReason(args) {
  let url = '/bbs/app/api/get/forbid_reason';
  return axiosGetHandler(url, args);
}
